<!--внимание. Этот компонент дублируется: 1 раз в ss-templates и 1 раз в vue.-->
<!--При необходимости внесения изменений в верстку - вносить в оба места.-->
<!--SCSS описан один раз: для ss-templates-компонента.-->
<!--Особенности, блять, микса vue с олдскульным подходом.-->
<style scoped lang="scss">
    @import 'src/scss/vars';    //от папки со сборкой
</style>

<template>
  <div class="cool-loader" :class="{'cool-loader--playing': isPlaying }">
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
    <span class="cool-loader-item"></span>
  </div>
</template>

<script>
    export default {
        data(){
            return {
                isPlaying: true,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/cool-loader-vue.vue